import { render, staticRenderFns } from "./UnverifiedProfile.vue?vue&type=template&id=03c66dce&scoped=true&"
import script from "./UnverifiedProfile.vue?vue&type=script&lang=js&"
export * from "./UnverifiedProfile.vue?vue&type=script&lang=js&"
import style0 from "./UnverifiedProfile.vue?vue&type=style&index=0&id=03c66dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c66dce",
  null
  
)

export default component.exports